import { Link, Section, Text } from 'react-email';
import { render } from '@react-email/render';
import * as React from 'react';
import {
  WATERLILY_LINKEDIN_URL,
  WATERLILY_TWITTER_URL,
} from '../templates/sharedTemplates';

const FONT_FAMILY = "'Helvetica Neue',Helvetica,Arial,sans-serif";
const MUTED = '#8886A5';

// Badges are pure HTML/CSS (no images) so they render even in clients that
// block remote images by default (Gmail, Outlook). Outlook desktop ignores
// border-radius and shows them as squares.
const badgeStyle: React.CSSProperties = {
  display: 'inline-block',
  width: '24px',
  height: '24px',
  borderRadius: '6px',
  color: '#FFFFFF',
  fontFamily: FONT_FAMILY,
  fontSize: '13px',
  fontWeight: 700,
  lineHeight: '24px',
  textAlign: 'center',
  textDecoration: 'none',
};

export function ModernEmailFooter({ emailPreferencesLink }: { emailPreferencesLink: string }) {
  return (
    <Section
      className="footer"
      style={{ padding: '20px 0' }}
    >
      <Text style={{ fontFamily: FONT_FAMILY, textAlign: 'center', margin: '0 0 16px' }}>
        <Link
          href={WATERLILY_TWITTER_URL}
          aria-label="Waterlily on X"
          style={{ ...badgeStyle, backgroundColor: '#000000' }}
        >
          X
        </Link>
        <span style={{ display: 'inline-block', width: '8px' }}>&nbsp;</span>
        <Link
          href={WATERLILY_LINKEDIN_URL}
          aria-label="Waterlily on LinkedIn"
          style={{ ...badgeStyle, backgroundColor: '#0A66C2' }}
        >
          in
        </Link>
      </Text>
      <Text
        style={{
          fontFamily: FONT_FAMILY,
          fontSize: '12px',
          color: MUTED,
          textAlign: 'center',
          margin: 0,
        }}
      >
        <Link
          href={emailPreferencesLink}
          style={{ fontSize: '12px', color: MUTED, textDecoration: 'underline' }}
        >
          Unsubscribe
        </Link>
      </Text>
    </Section>
  );
}

/**
 * Renders the footer as an HTML fragment for injection into an
 * already-rendered email at the modern footer placeholder. render() always
 * prepends a doctype, which has no place mid-document, so strip it.
 */
export async function renderModernEmailFooter(emailPreferencesLink: string): Promise<string> {
  const html = await render(<ModernEmailFooter emailPreferencesLink={emailPreferencesLink} />);
  return html.replace(/^<!DOCTYPE[^>]*>/i, '');
}
